import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const PricingSummary = ({ 
  pricingConfig, 
  onPricingConfigChange, 
  totalPrice,
  onGenerateQuote,
  isGenerating = false,
  isCollapsed = false,
  onToggleCollapse 
}) => {
  const handleConfigChange = (field, value) => {
    onPricingConfigChange({
      ...pricingConfig,
      [field]: value
    });
  };

  const vatOptions = [
    { value: 'self-liquidation', label: 'Auto-liquidation' },
    { value: '10', label: 'TVA 10%' },
    { value: '20', label: 'TVA 20%' }
  ];

  const clientCategoryOptions = [
    { value: 'individual', label: 'Particulier' },
    { value: 'professional', label: 'Professionnel' },
    { value: 'subcontractor', label: 'Sous-traitant' }
  ];

  const calculateVAT = () => {
    if (pricingConfig?.vat === 'self-liquidation') return 0;
    const vatRate = parseFloat(pricingConfig?.vat) / 100;
    return totalPrice * vatRate;
  };

  const calculateTotal = () => {
    return totalPrice + calculateVAT();
  };

  const mockPriceBreakdown = [
    { label: 'Meubles et éléments', amount: 2450.00 },
    { label: 'Plan de travail', amount: 890.00 },
    { label: 'Électroménager', amount: 650.00 },
    { label: 'Services additionnels', amount: 530.00 }
  ];

  return (
    <div className="bg-surface border border-border rounded-lg sticky top-4">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer lg:cursor-default"
        onClick={onToggleCollapse}
      >
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-full">
            <Icon name="Calculator" size={16} color="white" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-text-primary">Récapitulatif Prix</h3>
            <p className="text-sm text-text-secondary">Calcul en temps réel</p>
          </div>
        </div>
        <Icon 
          name={isCollapsed ? "ChevronDown" : "ChevronUp"} 
          size={20} 
          className="text-text-secondary lg:hidden" 
        />
      </div>
      <div className={`${isCollapsed ? 'hidden' : 'block'} lg:block`}>
        <div className="px-4 pb-4 border-t border-border">
          <div className="space-y-4 mt-4">
            <Select
              label="Catégorie client *"
              placeholder="Sélectionner la catégorie"
              options={clientCategoryOptions}
              value={pricingConfig?.clientCategory || ''}
              onChange={(value) => handleConfigChange('clientCategory', value)}
              required
            />

            <Select
              label="TVA *"
              placeholder="Sélectionner le taux de TVA"
              options={vatOptions}
              value={pricingConfig?.vat || ''}
              onChange={(value) => handleConfigChange('vat', value)}
              required
            />

            <div className="bg-muted rounded-lg p-4 space-y-3">
              <h4 className="text-sm font-medium text-text-primary">Détail des coûts</h4>
              {mockPriceBreakdown?.map((item, index) => (
                <div key={index} className="flex justify-between text-sm">
                  <span className="text-text-secondary">{item?.label}</span>
                  <span className="text-text-primary font-medium">
                    {item?.amount?.toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €
                  </span>
                </div>
              ))}
              
              <div className="border-t border-border pt-3">
                <div className="flex justify-between text-sm">
                  <span className="text-text-secondary">Sous-total HT</span>
                  <span className="text-text-primary font-medium">
                    {totalPrice?.toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €
                  </span>
                </div>
                
                {pricingConfig?.vat !== 'self-liquidation' && (
                  <div className="flex justify-between text-sm mt-1">
                    <span className="text-text-secondary">TVA ({pricingConfig?.vat}%)</span>
                    <span className="text-text-primary font-medium">
                      {calculateVAT()?.toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €
                    </span>
                  </div>
                )}
                
                <div className="flex justify-between text-lg font-semibold mt-2 pt-2 border-t border-border">
                  <span className="text-text-primary">Total TTC</span>
                  <span className="text-primary">
                    {calculateTotal()?.toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €
                  </span>
                </div>
              </div>
            </div>

            <Button
              variant="default"
              fullWidth
              iconName="FileText"
              iconPosition="left"
              onClick={onGenerateQuote}
              loading={isGenerating}
              disabled={!pricingConfig?.clientCategory || !pricingConfig?.vat}
            >
              {isGenerating ? 'Génération...' : 'Générer le Devis PDF'}
            </Button>

            <div className="text-xs text-text-secondary text-center">
              Le devis sera nommé automatiquement :\n{new Date()?.toLocaleDateString('fr-FR')?.replace(/\//g, '-')}_nom-client.pdf
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingSummary;